module.exports = __webpack_public_path__ + "img/boat-top.3091b138.jpg";